import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface DeleteFolderRequest {
  folderId: number
  deleteContent?: boolean
}

export const deleteFolder = async (data: DeleteFolderRequest) => {
  const { folderId, deleteContent } = data
  const response = await authAPI.delete(`/building-essential/folder/${folderId}`, {
    params: { deleteContent: deleteContent || undefined },
  })
  return response.data
}

export const useDeleteFolder = () => {
  return useMutation({
    mutationFn: deleteFolder,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
